export default __webpack_public_path__ + "static/media/img6.7d514694.zoom";